<template>
  <div class="vqb-group pa-1" :class="classObject">
    <div class="vqb-group-heading" :class="{ 'panel-heading': styled }">
      <div class="match-type-container" :class="{ 'form-inline': styled }">
        <v-layout row align-center>
          <div :class="{ 'form-group': styled }">
            <v-flex xs12 sm6 class="py-2 pl-2">
              <v-btn-toggle
                mandatory
                v-model="query.logicalOperator"
                depressed
                class="elevation-0"
              >
                <v-btn
                  v-for="matchType in labels.matchTypes"
                  :value="matchType.id"
                  :key="matchType.id"
                  class="elevation-0"
                  >{{ matchType.label }}</v-btn
                >
              </v-btn-toggle>
            </v-flex>
          </div>
          <v-spacer />
          <v-btn
            type="button"
            icon
            :class="{ 'close pull-right': styled }"
            v-if="this.depth > 1"
            @click="remove"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
      </div>
    </div>

    <div
      class="vqb-group-body pa-3"
      style="border-style: double; border: yellow !important; "
    >
      <div class="children">
        <component
          v-for="(child, index) in query.children"
          :key="index"
          :is="child.type"
          :type="child.type"
          :query.sync="child.query"
          :ruleTypes="ruleTypes"
          :rules="rules"
          :rule="ruleById(child.query.rule)"
          :index="index"
          :maxDepth="maxDepth"
          :depth="depth + 1"
          :styled="styled"
          :labels="labels"
          @child-deletion-requested="removeChild"
        ></component>
      </div>

      <div class="rule-actions" :class="{ 'form-inline': styled }">
        <div :class="{ 'form-group': styled }">
          <v-layout row align-center>
            <v-select
              class="pl-3"
              v-model="selectedRule"
              :items="rules"
              item-text="label"
              :return-object="true"
              :class="{ 'form-control': styled }"
            ></v-select>

            <v-btn
              type="button"
              @click="addRule"
              depressed
              :class="{ 'btn btn-default': styled }"
              v-html="labels.addRule"
            ></v-btn>
            <v-btn
              type="button"
              depressed
              :class="{ 'btn btn-default': styled }"
              v-if="this.depth < this.maxDepth"
              @click="addGroup"
              v-html="labels.addGroup"
            ></v-btn>
          </v-layout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LayerQueryBuilderRule from "@/pages/MapPage/Tools/Layers/LayerQueryBuilderRule.vue";

import deepClone from "./utilities.js";
export default {
  name: "layer-query-builder-group",
  components: {
    LayerQueryBuilderRule
  },
  props: [
    "ruleTypes",
    "type",
    "query",
    "rules",
    "index",
    "maxDepth",
    "depth",
    "styled",
    "labels"
  ],
  methods: {
    ruleById(ruleId) {
      let rule = null;
      this.rules.forEach(function(value) {
        if (value.id === ruleId) {
          rule = value;
          return false;
        }
      });
      return rule;
    },
    addRule() {
      let updated_query = deepClone(this.query);
      let child = {
        type: "layer-query-builder-rule",
        query: {
          rule: this.selectedRule.id,
          selectedOperator: this.selectedRule.operators[0],
          selectedOperand:
            typeof this.selectedRule.operands === "undefined"
              ? this.selectedRule.label
              : this.selectedRule.operands[0],
          value: null
        }
      };
      // A bit hacky, but `v-model` on `select` requires an array.
      if (this.ruleById(child.query.rule).type === "multi-select") {
        child.query.value = [];
      }
      updated_query.children.push(child);
      this.$emit("update:query", updated_query);
    },
    addGroup() {
      let updated_query = deepClone(this.query);
      if (this.depth < this.maxDepth) {
        updated_query.children.push({
          type: "layer-query-builder-group",
          query: {
            logicalOperator: this.labels.matchTypes[0].id,
            children: []
          }
        });
        this.$emit("update:query", updated_query);
      }
    },
    remove() {
      this.$emit("child-deletion-requested", this.index);
    },
    removeChild(index) {
      let updated_query = deepClone(this.query);
      updated_query.children.splice(index, 1);
      this.$emit("update:query", updated_query);
    }
  },
  data() {
    return {
      selectedRule: this.rules[0]
    };
  },
  mounted: function() {
    this.rules.sort();
  },
  computed: {
    classObject() {
      let classObject = {
        "panel panel-default": this.styled
      };
      classObject["depth-" + this.depth.toString()] = this.styled;
      return classObject;
    }
  }
};
</script>
